import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Shield, CreditCard, Users, Star, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-10 pb-12 sm:pt-16 sm:pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-gradient-to-b from-amber-50 via-orange-50 to-sky-50" data-id="element-89">
      {/* Decorative color blobs */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-0" data-id="element-90">
        <div className="absolute top-10 -left-20 w-72 h-72 bg-amber-200 rounded-full blur-3xl opacity-40" data-id="element-91" />
        <div className="absolute top-40 -right-20 w-80 h-80 bg-sky-200 rounded-full blur-3xl opacity-40" data-id="element-92" />
        <div className="absolute bottom-0 left-1/3 w-72 h-72 bg-rose-200 rounded-full blur-3xl opacity-30" data-id="element-93" />
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-94">
        <div className="text-center max-w-4xl mx-auto" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center justify-center px-3 py-1 sm:px-4 sm:py-1.5 mb-4 sm:mb-6 text-xs sm:text-sm font-bold tracking-wide text-brand-dark bg-brand-accent/20 border border-brand-accent/50 rounded-full uppercase" data-id="element-96">
            6 + 3 Tomos + Bonos
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight text-[#3A61A3]" data-id="element-97">
            TODO TU AÑO DE PRESUPUESTOS DE REMODELACIÓN RESUELTO
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-98">
            Tu sistema completo de cotización in situ listo: desgloses por
            ambientes, flujos de cierre, blindaje legal, estrategias contra
            objeciones y reactivación. Multiplicá por 3 tus cierres y pasá de la
            visita al contrato comercial firmado en menos de 15 minutos. Sin
            perder dinero por malas estimaciones.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="relative max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-99">
          <div className="absolute inset-0 bg-brand-blue/5 rounded-3xl transform -rotate-2 scale-105 -z-10" data-id="element-100"></div>
          <motion.img animate={{
          y: [0, -12, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/agijaF1QbHgcxAHN39X4mX/png_con_fondo_transparente.png" alt="Kit de Presupuestos Rápidos Resuelto" width="1920" height="1080" fetchPriority="high" decoding="async" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-101" />

          <div className="absolute -bottom-4 sm:-bottom-6 left-1/2 transform -translate-x-1/2 flex flex-wrap justify-center gap-2 sm:gap-3 w-full max-w-2xl px-2 sm:px-4" data-id="element-102">
            <span className="bg-white text-brand-dark font-bold px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow-md border border-gray-100 text-xs sm:text-sm flex items-center" data-id="element-103">
              📄 PDF digital
            </span>
            <span className="bg-white text-brand-dark font-bold px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow-md border border-gray-100 text-xs sm:text-sm flex items-center" data-id="element-104">
              ⚡ Acceso Inmediato
            </span>
            <span className="bg-brand-dark text-white font-medium px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow-md text-xs sm:text-sm flex items-center text-center" data-id="element-105">
              Arquitectos - Diseñadores - Contratistas - Maestros de Obra
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="text-center mt-12 sm:mt-16" data-id="element-106">
          <div className="relative inline-block w-full sm:w-auto mb-6" data-id="element-107">
            <div className="absolute inset-0 bg-brand-accent rounded-lg animate-ping opacity-30" data-id="element-108"></div>
            <Button size="xl" onClick={() => {
            const el = document.getElementById('pricing');
            if (el) el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} className="relative w-full sm:w-auto shadow-xl shadow-brand-accent/20" data-id="element-109">
              💥 QUIERO MIS PRESUPUESTOS RESUELTOS AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-2 sm:gap-y-3 text-xs sm:text-sm text-gray-600 font-medium" data-id="element-110">
            <span className="flex items-center" data-id="element-111">
              <Shield className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-1.5 text-green-600" data-id="element-112" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-113">
              <CreditCard className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-1.5 text-blue-600" data-id="element-114" />{' '}
              Pago seguro
            </span>
            <span className="flex items-center" data-id="element-115">
              <span className="font-bold text-blue-500 mr-1 sm:mr-1.5" data-id="element-116">mp</span>{' '}
              Mercado Pago
            </span>
            <span className="flex items-center" data-id="element-117">
              <Users className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-1.5 text-brand-dark" data-id="element-118" />{' '}
              +500 Profesionales
            </span>
            <span className="flex items-center" data-id="element-119">
              <Star className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-1.5 text-brand-accent fill-brand-accent" data-id="element-120" />{' '}
              Calificación de 4.9
            </span>
            <span className="flex items-center" data-id="element-121">
              <MapPin className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-1.5 text-red-500" data-id="element-122" />{' '}
              Todo Argentina
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}